(function () {
  'use strict';

  if (!document.querySelector('[data-title-filters]')) return;

  var GROUPS = ['modelo', 'capacidad', 'bateria'];
  var URL_KEYS = { modelo: 'modelo', capacidad: 'capacidad', bateria: 'bateria' };

  // Battery health buckets (in %). A reading falls in a bucket when min <= val < max,
  // except the last bucket which is inclusive on both ends so 100% has a home.
  var BATTERY_BUCKETS = [
    { slug: '75-80',  label: 'Arriba de 75%', min: 75, max: 80,  sortKey: 1 },
    { slug: '80-85',  label: '80% - 85%',     min: 80, max: 85,  sortKey: 2 },
    { slug: '85-90',  label: '85% - 90%',     min: 85, max: 90,  sortKey: 3 },
    { slug: '90-95',  label: '90% - 95%',     min: 90, max: 95,  sortKey: 4 },
    { slug: '95-100', label: '95% - 100%',    min: 95, max: 101, sortKey: 5 }
  ];

  // Variant ranking within a generation: lower number = higher in the list
  var VARIANT_ORDER = {
    'pro max': 0,
    'pro': 1,
    'air': 2,
    'plus': 3,
    '': 4,
    'mini': 5
  };

  var VARIANT_DISPLAY = {
    'pro max': 'Pro Max',
    'pro': 'Pro',
    'air': 'Air',
    'plus': 'Plus',
    '': '',
    'mini': 'mini'
  };

  // Regex to match an iPhone model in a title.
  // Examples it should match (case-insensitive):
  //   "iPhone 14"      → gen=14, variant=""
  //   "iPhone 13 Pro Max"  → gen=13, variant="Pro Max"
  //   "iPhone 17 Air"  → gen=17, variant="Air"
  //   "iPhone SE"      → gen="SE", variant=""
  //   "iPhone XR"      → gen="XR", variant=""
  // Variant alternation puts longest first so "Pro Max" wins over "Pro".
  var MODEL_REGEX = /i\s*phone\s+(\d{1,2}|se|xs\s*max|xr|xs|x)(?:\s+(pro\s*max|pro|air|plus|mini))?/i;
  var MEMORY_REGEX = /\b(\d+)\s*(gb|tb)\b/i;
  // Matches "salud de batería 88%", "salud de bateria 100 %", "Salud de Batería: 95%", etc.
  var BATTERY_REGEX = /salud\s+de\s+bater[ií]a\s*[:\-]?\s*(\d{1,3})\s*%/i;

  function parseModel(title) {
    if (!title) return null;
    var m = title.match(MODEL_REGEX);
    if (!m) return null;
    var rawGen = m[1].toLowerCase().replace(/\s+/g, ' ').trim();
    var rawVariant = (m[2] || '').toLowerCase().replace(/\s+/g, ' ').trim();
    return { gen: rawGen, variant: rawVariant };
  }

  function parseCapacity(title) {
    if (!title) return null;
    var m = title.match(MEMORY_REGEX);
    if (!m) return null;
    var num = parseInt(m[1], 10);
    var unit = m[2].toUpperCase();
    if (!num || isNaN(num)) return null;
    return { num: num, unit: unit };
  }

  function parseBattery(title) {
    if (!title) return null;
    var m = title.match(BATTERY_REGEX);
    if (!m) return null;
    var val = parseInt(m[1], 10);
    if (isNaN(val) || val < 0 || val > 100) return null;
    for (var i = 0; i < BATTERY_BUCKETS.length; i++) {
      var b = BATTERY_BUCKETS[i];
      if (val >= b.min && val < b.max) return b;
    }
    return null; // value below the lowest bucket (e.g., < 75%)
  }

  function modelLabel(parsed) {
    var gen = parsed.gen;
    var displayGen;
    if (gen === 'se') displayGen = 'SE';
    else if (gen === 'x') displayGen = 'X';
    else if (gen === 'xr') displayGen = 'XR';
    else if (gen === 'xs') displayGen = 'XS';
    else if (gen === 'xs max') displayGen = 'XS Max';
    else displayGen = gen;
    var variant = VARIANT_DISPLAY[parsed.variant] || '';
    return ('iPhone ' + displayGen + (variant ? ' ' + variant : '')).trim();
  }

  function modelSlug(parsed) {
    var gen = parsed.gen.replace(/\s+/g, '-');
    var variant = parsed.variant.replace(/\s+/g, '-');
    return ('iphone-' + gen + (variant ? '-' + variant : '')).toLowerCase();
  }

  function modelSortKey(parsed) {
    // Higher = appears first. Modern numbered iPhones go highest.
    var gen = parsed.gen;
    var primary;
    if (/^\d+$/.test(gen)) {
      primary = 1000 + parseInt(gen, 10); // 11..17 → 1011..1017
    } else if (gen === 'xs max' || gen === 'xs' || gen === 'xr' || gen === 'x') {
      primary = 100 + (gen === 'xs max' ? 4 : gen === 'xs' ? 3 : gen === 'xr' ? 2 : 1);
    } else if (gen === 'se') {
      primary = 50;
    } else {
      primary = 0;
    }
    var secondary = (VARIANT_ORDER[parsed.variant] != null) ? VARIANT_ORDER[parsed.variant] : 9;
    return primary * 10 - secondary;
  }

  function capacityLabel(parsed) {
    return parsed.num + parsed.unit;
  }

  function capacitySlug(parsed) {
    return (parsed.num + parsed.unit).toLowerCase();
  }

  function capacitySortKey(parsed) {
    return parsed.unit === 'TB' ? parsed.num * 1024 : parsed.num;
  }

  // Extract product handle from a card's link.
  function getCardHandle(card) {
    var link = card.querySelector('a.collection-view-image, a[href*="/products/"]');
    if (!link) return null;
    var href = link.getAttribute('href') || '';
    var match = href.match(/\/products\/([^/?#]+)/);
    return match ? match[1] : null;
  }

  function getCardTitle(card) {
    var titleEl = card.querySelector('.product-item__title');
    if (titleEl) return (titleEl.textContent || '').trim();
    return null;
  }

  // ----- State -----
  var state = {
    cards: [],            // [{ el, handle, title, modelSlug, capacitySlug, batterySlug }]
    options: { modelo: [], capacidad: [], bateria: [] }, // [{ value, label, count, sortKey }]
    selected: { modelo: new Set(), capacidad: new Set(), bateria: new Set() }
  };

  function indexCards() {
    var grid = document.getElementById('product-grid');
    if (!grid) return;
    var cardEls = grid.querySelectorAll('.product-item');
    state.cards = [];
    var modelMap = {}; // slug -> { label, count, sortKey }
    var capMap = {};
    var batMap = {};

    for (var i = 0; i < cardEls.length; i++) {
      var card = cardEls[i];
      var title = getCardTitle(card);
      var handle = getCardHandle(card);
      var entry = { el: card, handle: handle, title: title || '', modelSlug: null, capacitySlug: null, batterySlug: null };

      if (title) {
        var parsedModel = parseModel(title);
        if (parsedModel) {
          var mSlug = modelSlug(parsedModel);
          entry.modelSlug = mSlug;
          if (!modelMap[mSlug]) {
            modelMap[mSlug] = { value: mSlug, label: modelLabel(parsedModel), count: 0, sortKey: modelSortKey(parsedModel) };
          }
          modelMap[mSlug].count++;
        }
        var parsedCap = parseCapacity(title);
        if (parsedCap) {
          var cSlug = capacitySlug(parsedCap);
          entry.capacitySlug = cSlug;
          if (!capMap[cSlug]) {
            capMap[cSlug] = { value: cSlug, label: capacityLabel(parsedCap), count: 0, sortKey: capacitySortKey(parsedCap) };
          }
          capMap[cSlug].count++;
        }
        var parsedBat = parseBattery(title);
        if (parsedBat) {
          entry.batterySlug = parsedBat.slug;
          if (!batMap[parsedBat.slug]) {
            batMap[parsedBat.slug] = { value: parsedBat.slug, label: parsedBat.label, count: 0, sortKey: parsedBat.sortKey };
          }
          batMap[parsedBat.slug].count++;
        }
      }
      state.cards.push(entry);
    }

    state.options.modelo = Object.keys(modelMap)
      .map(function (k) { return modelMap[k]; })
      // Ascending by phone hierarchy: oldest generation first, and within a
      // generation from lowest tier to highest (mini → base → Plus → Air → Pro → Pro Max).
      .sort(function (a, b) { return a.sortKey - b.sortKey; });
    state.options.capacidad = Object.keys(capMap)
      .map(function (k) { return capMap[k]; })
      .sort(function (a, b) { return a.sortKey - b.sortKey; });
    state.options.bateria = Object.keys(batMap)
      .map(function (k) { return batMap[k]; })
      .sort(function (a, b) { return a.sortKey - b.sortKey; });
  }

  function readUrlParams() {
    var params = new URLSearchParams(window.location.search);
    GROUPS.forEach(function (g) {
      state.selected[g] = new Set();
      var raw = params.get(URL_KEYS[g]);
      if (!raw) return;
      raw.split(',').forEach(function (v) {
        v = v.trim();
        if (v) state.selected[g].add(v);
      });
    });
  }

  function writeUrlParams() {
    var params = new URLSearchParams(window.location.search);
    GROUPS.forEach(function (g) {
      var values = Array.from(state.selected[g]);
      if (values.length > 0) {
        params.set(URL_KEYS[g], values.join(','));
      } else {
        params.delete(URL_KEYS[g]);
      }
    });
    var qs = params.toString();
    var newUrl = window.location.pathname + (qs ? '?' + qs : '') + window.location.hash;
    window.history.replaceState({}, '', newUrl);
  }

  function renderGroup(group) {
    var lists = document.querySelectorAll('[data-tf-group="' + group + '"]');
    var options = state.options[group];
    var selected = state.selected[group];

    lists.forEach(function (list) {
      list.innerHTML = '';
      if (!options.length) {
        var empty = document.createElement('li');
        empty.className = 'title-filters__empty-group';
        empty.textContent = 'Sin opciones';
        list.appendChild(empty);
        return;
      }
      options.forEach(function (opt) {
        var li = document.createElement('li');
        var label = document.createElement('label');
        label.className = 'title-filters__option';

        var input = document.createElement('input');
        input.type = 'checkbox';
        input.value = opt.value;
        input.dataset.tfInput = group;
        input.checked = selected.has(opt.value);
        input.addEventListener('change', onCheckboxChange);

        var span = document.createElement('span');
        span.className = 'title-filters__option-label';
        span.textContent = opt.label;

        var count = document.createElement('span');
        count.className = 'title-filters__option-count';
        count.textContent = '(' + opt.count + ')';

        label.appendChild(input);
        label.appendChild(span);
        label.appendChild(count);
        li.appendChild(label);
        list.appendChild(li);
      });
    });
  }

  function onCheckboxChange(e) {
    var group = e.target.dataset.tfInput;
    var value = e.target.value;
    if (e.target.checked) {
      state.selected[group].add(value);
    } else {
      state.selected[group].delete(value);
    }
    // Sync the matching checkbox in the other context (desktop ↔ mobile)
    document.querySelectorAll('input[data-tf-input="' + group + '"][value="' + value.replace(/"/g, '\\"') + '"]').forEach(function (input) {
      if (input !== e.target) input.checked = e.target.checked;
    });
    applyFilters();
  }

  function renderPillsGroup(group) {
    var scroller = document.querySelector('[data-tf-pills="' + group + '"]');
    if (!scroller) return;
    var options = state.options[group];
    var selected = state.selected[group];
    var row = scroller.closest('[data-tf-pills-row]');

    scroller.innerHTML = '';

    // Hide the row only when there are zero options. With a single option we
    // still render it so a preselected (e.g. URL-deep-linked) filter remains
    // toggleable on mobile.
    if (!options.length) {
      if (row) row.style.display = 'none';
      return;
    }
    if (row) row.style.display = '';

    options.forEach(function (opt) {
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'title-filters__pill' + (selected.has(opt.value) ? ' is-active' : '');
      btn.dataset.tfPill = group;
      btn.dataset.tfPillValue = opt.value;
      btn.setAttribute('aria-pressed', selected.has(opt.value) ? 'true' : 'false');
      btn.innerHTML = '<span>' + escapeHtml(opt.label) + '</span><span class="title-filters__pill-count">(' + opt.count + ')</span>';
      btn.addEventListener('click', onPillClick);
      scroller.appendChild(btn);
    });
  }

  function onPillClick(e) {
    var btn = e.currentTarget;
    var group = btn.dataset.tfPill;
    var value = btn.dataset.tfPillValue;
    var nowSelected;
    if (state.selected[group].has(value)) {
      state.selected[group].delete(value);
      nowSelected = false;
    } else {
      state.selected[group].add(value);
      nowSelected = true;
    }
    // Sync the matching checkbox in the desktop sidebar (and mobile drawer if present)
    document.querySelectorAll('input[data-tf-input="' + group + '"][value="' + value.replace(/"/g, '\\"') + '"]').forEach(function (input) {
      input.checked = nowSelected;
    });
    applyFilters();
  }

  function updatePillsActiveState() {
    GROUPS.forEach(function (group) {
      var pills = document.querySelectorAll('[data-tf-pill="' + group + '"]');
      var selected = state.selected[group];
      pills.forEach(function (pill) {
        var isActive = selected.has(pill.dataset.tfPillValue);
        pill.classList.toggle('is-active', isActive);
        pill.setAttribute('aria-pressed', isActive ? 'true' : 'false');
      });
    });
  }

  function applyFilters() {
    var modelSel = state.selected.modelo;
    var capSel = state.selected.capacidad;
    var batSel = state.selected.bateria;
    var visibleCount = 0;
    var totalCount = state.cards.length;

    state.cards.forEach(function (entry) {
      var matchesModel = modelSel.size === 0 || (entry.modelSlug && modelSel.has(entry.modelSlug));
      var matchesCap = capSel.size === 0 || (entry.capacitySlug && capSel.has(entry.capacitySlug));
      var matchesBat = batSel.size === 0 || (entry.batterySlug && batSel.has(entry.batterySlug));
      if (matchesModel && matchesCap && matchesBat) {
        entry.el.style.display = '';
        visibleCount++;
      } else {
        entry.el.style.display = 'none';
      }
    });

    renderActiveChips();
    updatePillsActiveState();
    renderResultsCount(visibleCount, totalCount);
    renderEmptyState(visibleCount);
    renderClearButton();
    renderMobileBadge();
    writeUrlParams();
  }

  function renderActiveChips() {
    var container = document.querySelector('[data-tf-active-chips]');
    if (!container) return;
    container.innerHTML = '';
    GROUPS.forEach(function (group) {
      state.selected[group].forEach(function (val) {
        var opt = state.options[group].find(function (o) { return o.value === val; });
        if (!opt) return;
        var chip = document.createElement('button');
        chip.type = 'button';
        chip.className = 'title-filters__chip';
        chip.dataset.tfChipGroup = group;
        chip.dataset.tfChipValue = val;
        chip.innerHTML = '<span>' + escapeHtml(opt.label) + '</span><span class="title-filters__chip-x">×</span>';
        chip.addEventListener('click', function () {
          state.selected[group].delete(val);
          // Uncheck all matching inputs
          document.querySelectorAll('input[data-tf-input="' + group + '"][value="' + val.replace(/"/g, '\\"') + '"]').forEach(function (i) {
            i.checked = false;
          });
          applyFilters();
        });
        container.appendChild(chip);
      });
    });
  }

  function renderResultsCount(visible, total) {
    var existing = document.querySelector('[data-tf-results-count]');
    if (!existing) return;
    if (state.selected.modelo.size === 0 && state.selected.capacidad.size === 0) {
      existing.textContent = '';
      existing.style.display = 'none';
    } else {
      existing.style.display = '';
      existing.textContent = visible + ' de ' + total + ' resultados';
    }
  }

  function renderEmptyState(visible) {
    var emptyEl = document.querySelector('[data-tf-empty]');
    var grid = document.getElementById('product-grid');
    if (!emptyEl || !grid) return;
    var hasActive = state.selected.modelo.size > 0 || state.selected.capacidad.size > 0 || state.selected.bateria.size > 0;
    if (visible === 0 && hasActive) {
      emptyEl.hidden = false;
      grid.style.display = 'none';
    } else {
      emptyEl.hidden = true;
      grid.style.display = '';
    }
  }

  function renderClearButton() {
    var hasActive = state.selected.modelo.size > 0 || state.selected.capacidad.size > 0 || state.selected.bateria.size > 0;
    document.querySelectorAll('[data-tf-clear]').forEach(function (btn) {
      btn.hidden = !hasActive;
    });
  }

  function renderMobileBadge() {
    var total = state.selected.modelo.size + state.selected.capacidad.size + state.selected.bateria.size;
    document.querySelectorAll('[data-tf-mobile-active-count]').forEach(function (el) {
      el.textContent = total > 0 ? String(total) : '';
    });
  }

  function clearAll() {
    GROUPS.forEach(function (g) { state.selected[g] = new Set(); });
    document.querySelectorAll('input[data-tf-input]').forEach(function (input) {
      input.checked = false;
    });
    applyFilters();
  }

  function bindGlobalControls() {
    document.querySelectorAll('[data-tf-clear]').forEach(function (btn) {
      btn.addEventListener('click', function (e) { e.preventDefault(); clearAll(); });
    });

    var openBtn = document.querySelector('[data-tf-mobile-open]');
    var drawer = document.querySelector('[data-tf-drawer]');
    var panel = drawer ? drawer.querySelector('.title-filters-drawer__panel') : null;

    function openDrawer() {
      if (!drawer) return;
      drawer.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      if (openBtn) openBtn.setAttribute('aria-expanded', 'true');
      if (panel) {
        // Focus the panel so screen readers and keyboard users land inside the dialog
        setTimeout(function () { panel.focus(); }, 50);
      }
    }

    function closeDrawer() {
      if (!drawer) return;
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      if (openBtn) {
        openBtn.setAttribute('aria-expanded', 'false');
        openBtn.focus();
      }
    }

    if (openBtn && drawer) {
      openBtn.addEventListener('click', openDrawer);
    }
    if (drawer) {
      drawer.querySelectorAll('[data-tf-drawer-close]').forEach(function (el) {
        el.addEventListener('click', closeDrawer);
      });
      // Close on Escape when the drawer is open
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && drawer.classList.contains('is-open')) {
          closeDrawer();
        }
      });
    }
  }

  function escapeHtml(str) {
    return String(str).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function init() {
    indexCards();
    readUrlParams();

    // Drop selected values that no longer correspond to any current option
    GROUPS.forEach(function (g) {
      var validValues = new Set(state.options[g].map(function (o) { return o.value; }));
      state.selected[g] = new Set(Array.from(state.selected[g]).filter(function (v) { return validValues.has(v); }));
    });

    GROUPS.forEach(renderGroup);
    GROUPS.forEach(renderPillsGroup);
    bindGlobalControls();
    applyFilters();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
